<template>
  <div class="home-content-page">
    <div class="two-content">
      <mii-table :datas="orderWeight" :table_style="2" :ths="ths" :title="sourceDataType === 'shop' ? '订单重量' : '订单量'"  :canEdit.sync="canEdit" :row_num="10" :show_pagination="true"></mii-table>
      <div class="gu-duan">
      </div>
      <mii-table :datas="orderVolume" :table_style="1" :ths="ths" :title="sourceDataType === 'shop' ? '订单体积' : '有效容积'" :canEdit.sync="canEdit" :row_num="10" :show_pagination="true"></mii-table>
    </div>
    <div class="gu-duan-width">
    </div>
    <div class="one-content">
      <week-data :datas="orderDays" title="订货时间"></week-data>
    </div>
  </div>
</template>

<script>
  import MiiTable from '../components_bit/MiiTable'
  import WeekData from '../components_bit/WeekData'
  export default {
    components: {
      MiiTable,
      WeekData
    },
    computed: {
      canEdit: {
        get () {
          return this.$store.getters.solutionStatus < 21
        }
      },
      sourceDataType: {
        get () {
          return this.$store.getters.sourceDataType
        }
      },
      orderWeight: {
        get () {
          return this.$store.getters.orderWeight
        }
      },
      orderVolume: {
        get () {
          return this.$store.getters.orderVolume
        }
      },
      orderDays: {
        get () {
          return this.$store.getters.orderDays
        }
      },
      ths: {
        get () {
          let ths = [{
            key: 'shop'
          },
          {
            key: 'dry'
          },
          {
            key: 'Fresh'
          },
          {
            key: 'frozen'
          }]
          let labels = this.$store.getters.sourceDataField[this.$store.getters.sourceDataType]
          ths.forEach(function (item) {
            item.label = labels[item.key]
          })
          return ths
        }
      }
    }
  }
</script>

<style scoped lang="less">
  @import '../style/base.less';
  .two-content {
    flex:1;
    display: flex;
    flex-direction:column;
    height: 54em;
  }
  .one-content {
    flex:1;
    display: felx;
  }
  .gu-duan {
    width: 100%;
    height: 1.3em;
  }
  .gu-duan-width {
    width: 1.3em;
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// source_data.vue?59fe3de8